import { Form } from 'react-hook-form';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';

import { media } from '../layout';

export const EntityForm = styled(Form)`
  width: 100%;
  height: 100%;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FormSections = styled.div`
  background-color: ${COLORS.systemLight100};
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

export const GroupSection = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;

  ${media.isMobile} {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
`;
